"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadRequestError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */
class BadRequestError extends client_library_1.ExtendableError {
}
exports.BadRequestError = BadRequestError;
//# sourceMappingURL=BadRequestError.js.map